import { ResetPasswordForm } from "@/components/auth/reset-password-form";
import { ShimmeringDisc } from "@/components/ui/shimmering-disc";
import { useSearch } from "wouter";

export default function ResetPassword() {
  const search = useSearch();
  const token = search
    ? new URLSearchParams(search).get("token")
    : undefined;

  return (
    <div className="min-h-screen bg-clubhouse-black flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-[360px] animate-page-in">
        {/* Logo */}
        <div className="flex flex-col items-center gap-3 mb-12">
          <ShimmeringDisc size={72} />
          <span className="text-white/90 text-[14px] font-medium tracking-widest uppercase">
            Clubhouse FM
          </span>
        </div>

        {/* Form */}
        <ResetPasswordForm token={token ?? undefined} />

        {/* Footer */}
        <div className="flex flex-col items-center gap-4 mt-10">
          <div className="flex items-center gap-3">
            <a href="https://clubhousefm.com" target="_blank" rel="noopener noreferrer" className="text-[14px] text-white/30 hover:text-white/50 transition-colors">
              clubhousefm.com
            </a>
            <span className="text-white/15">&middot;</span>
            <a href="https://www.youtube.com/@clubhousefm" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/50 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
